import React from 'react'

const EmptyCart = () => {
  return (
    <div>your cart is empty </div>
  )
}

export default EmptyCart